import api from "../../utils/apiUserTienda";

export const getMetodosEnvio = async ({ page = 1, limit = 20 } = {}) => {
  const res = await api.get("/api/tienda/metodos_envio/obtener", {
    params: { page, limit },
  });
  return res.data;
};

export const crearMetodoEnvio = async (data) => {
  const res = await api.post("/api/tienda/metodos_envio/crear", data);
  return res.data;
};

export const actualizarMetodoEnvio = async (id, data) => {
  const res = await api.put(`/api/tienda/metodos_envio/actualizar/${id}`, data);
  return res.data;
};

export const getMetodosEnvioId = async (id) => {
  const res = await api.get(`/api/tienda/metodos_envio/obtener/${id}`);
  return res.data;
};

export const crearReglaMetodoEnvio = async (metodoEnvioId, data) => {
const res = await api.post( `/api/tienda/metodos_envio/${metodoEnvioId}/reglas/crear`,
data
);
return res.data;
};

export const actualizarReglaMetodoEnvio = async (metodoEnvioId, reglaId,data) => {
const res = await api.put(`/api/tienda/metodos_envio/${metodoEnvioId}/reglas/actualizar/${reglaId}`,
data
);
return res.data;
};

export const eliminarReglaMetodoEnvio = async (metodoEnvioId, reglaId) => {
  const res = await api.delete(
    `/api/tienda/metodos_envio/${metodoEnvioId}/reglas/${reglaId}`
  );
  return res.data;
};
